import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

// Tus imágenes
import cards1 from "../images/cards1.png";
import cards2 from "../images/cards2.png";
import cards3 from "../images/cards3.png";
import cards4 from "../images/cards4.png";
import cards5 from "../images/cards5.png";
import cards6 from "../images/cards6.png";

const useStyles = makeStyles((theme) => ({
  // Aplicamos la fuente Paralucent globalmente para todo el body
  "@global": {
    body: {
      fontFamily: "Paralucent, sans-serif",
    },
  },
  rootGrid: {
    marginTop: "20px",
  },
  gridItem: {
    display: "flex",
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f2f2f2", // Gris muy claro
  },
  cardActionArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  media: {
    height: 200,
    width: "100%",
  },
  title: {
    fontSize: "2rem",
    fontFamily: "Paralucent, sans-serif", // Actualizado a Paralucent
    fontWeight: 700,
    margin: theme.spacing(1, 0),
    textAlign: "center",
  },
  cardContent: {
    flex: 1,
  },
  bodyText: {
    fontSize: "1.3rem",
    lineHeight: 1.3,
    fontFamily: "Paralucent, sans-serif", // Actualizado a Paralucent
  },
  // Clase para el texto introductorio
  introText: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    fontSize: "1.6rem",
    fontFamily: "Paralucent, sans-serif", // Actualizado a Paralucent
    lineHeight: 1.5,
    textAlign: "justify",
  },
}));

/**
 * Función para formatear el texto:
 * - Si contiene '▪', lo separa en viñetas con ícono de check.
 * - Si no, lo muestra como texto normal.
 */
function formatText(text, classes) {
  if (text && text.includes("▪")) {
    const items = text.split("▪").filter(Boolean);
    return (
      <List disablePadding>
        {items.map((item, index) => (
          <ListItem key={index} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <ListItemIcon>
              <CheckCircleIcon style={{ color: "black" }} />
            </ListItemIcon>
            <ListItemText
              primary={item.trim()}
              classes={{ primary: classes.bodyText }}
            />
          </ListItem>
        ))}
      </List>
    );
  } else {
    return (
      <Typography variant="body1" component="p" className={classes.bodyText}>
        {text}
      </Typography>
    );
  }
}

const StaticCards = () => {
  const classes = useStyles();

  // Texto introductorio
  const textoIntro = `
En Q2, somos especialistas en brindar soluciones tecnológicas innovadoras para la gestión de
acreditaciones en eventos. Nuestro enfoque combina eficiencia, seguridad y personalización,
permitiendo a organizadores y asistentes disfrutar de una experiencia fluida desde el registro
hasta el cierre del evento. Con un sistema desarrollado completamente por nuestro equipo,
garantizamos una plataforma moderna, adaptable y de alto rendimiento, diseñada para satisfacer
las necesidades de cada cliente y maximizar el éxito de sus eventos.
`;

  // Array de 6 cards con contenido e imagen
  const cards = [
    {
      id: 1,
      image: cards1,
      title: "Registro previo",
      text: "Los participantes completan un formulario de registro en línea a través de un enlace personalizado. Opcionalmente, se pueden integrar pasarelas de venta para eventos pagos.",
    },
    {
      id: 2,
      image: cards2,
      title: "Confirmación automática",
      text: "Una vez registrado, cada participante recibe un correo electrónico o mensaje con su conﬁrmación de inscripción. Incluye un código QR único o enlace para agilizar el proceso de acreditación el día del evento.",
    },
    {
      id: 3,
      image: cards3,
      title: "Check-in en el evento",
      text: " Los asistentes presentan su código QR en los puntos de acceso. ▪ Nuestro sistema escanea y valida la información en segundos. ▪ Opciones adicionales como impresión de credenciales en el momento.",
    },
    {
      id: 4,
      image: cards4,
      title: "Monitoreo en tiempo real",
      text: "▪ Los organizadores pueden ver estadísticas actualizadas desde un panel: ▪  Número de asistentes registrados y acreditados. ▪ Tiempos de espera y ﬂujo en los puntos de acceso. ▪ Alertas automáticas en caso de cualquier incidencia.",
    },
    {
      id: 5,
      image: cards5,
      title: "Gestión posterior al evento",
      text: "Generación de reportes detallados con métricas clave: Asistencia total y por horarios. Segmentación por tipo de acreditación. ▪ Integración con herramientas CRM o bases de datos para futuras estrategias de comunicación.",
    },
    {
      id: 6,
      image: cards6,
      title: "Conclusiones",
      text: "La integración de todos estos pasos en un único sistema permite a Q2 ofrecer una solución robusta y flexible que maximiza la eficiencia y la satisfacción de organizadores y asistentes. Con monitoreo en tiempo real, reportes detallados y opciones de personalización, Q2 se adapta a cualquier tipo de evento, garantizando un proceso fluido desde el registro hasta la gestión posterior. De este modo, se optimizan recursos y se eleva la experiencia global, logrando que cada encuentro sea un éxito tanto para quienes lo planifican como para quienes participan.",
    },
  ];

  return (
    <Container>
      {/* Texto introductorio antes de las cards */}
      <Typography variant="body1" className={classes.introText}>
        {textoIntro}
      </Typography>

      <Grid
        container
        spacing={2}
        className={classes.rootGrid}
        alignItems="stretch"
      >
        {cards.map((card) => (
          <Grid item xs={12} sm={4} md={4} key={card.id} className={classes.gridItem}>
            <Card className={classes.card}>
              <CardActionArea className={classes.cardActionArea}>
                <CardMedia
                  className={classes.media}
                  image={card.image}
                  title={`Card ${card.id}`}
                />
                <Typography
                  variant="h6"
                  component="h2"
                  className={classes.title}
                >
                  {card.title}
                </Typography>
                <CardContent className={classes.cardContent}>
                  {formatText(card.text, classes)}
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default StaticCards;
